import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const MuseumIcon = ({ className = '', width = 23,  height = 18 , color = 'currentColor' }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={height}
            viewBox='0 0 23 18'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M20.7002 1H2.7002C2.14791 1 1.7002 1.44772 1.7002 2V16C1.7002 16.5523 2.14791 17 2.70019 17H20.7002C21.2525 17 21.7002 16.5523 21.7002 16V2C21.7002 1.44771 21.2525 1 20.7002 1ZM2.7002 0C1.59563 0 0.700195 0.89543 0.700195 2V16C0.700195 17.1046 1.59563 18 2.70019 18H20.7002C21.8048 18 22.7002 17.1046 22.7002 16V2C22.7002 0.895431 21.8048 0 20.7002 0H2.7002Z'
                fill={color}
                fillRule='evenodd'/>
            <path
                clipRule='evenodd'
                d='M9.7002 6C9.7002 7.10457 8.80476 8 7.7002 8C6.59563 8 5.7002 7.10457 5.7002 6C5.7002 4.89543 6.59563 4 7.7002 4C8.80476 4 9.7002 4.89543 9.7002 6ZM7.7002 7C8.25248 7 8.7002 6.55228 8.7002 6C8.7002 5.44772 8.25248 5 7.7002 5C7.14791 5 6.7002 5.44772 6.7002 6C6.7002 6.55228 7.14791 7 7.7002 7Z'
                fill={color}
                fillRule='evenodd'/>
            <path
                clipRule='evenodd'
                d='M4.7002 3H18.7002C19.2525 3 19.7002 3.44772 19.7002 4V4.8094L14.3711 10.7816L11.3151 7.87107L3.7002 12.6008V4C3.7002 3.44772 4.14791 3 4.7002 3ZM3.7002 13.778L3.46415 13.9246L2.93652 13.0751L3.7002 12.6008V13.778ZM3.7002 13.778L11.1856 9.1287L14.4295 12.2182L19.7002 6.31138V14C19.7002 14.5523 19.2525 15 18.7002 15H4.7002C4.14791 15 3.7002 14.5523 3.7002 14V13.778ZM2.7002 4C2.7002 2.89543 3.59563 2 4.7002 2H18.7002C19.8048 2 20.7002 2.89543 20.7002 4V14C20.7002 15.1046 19.8048 16 18.7002 16H4.7002C3.59563 16 2.7002 15.1046 2.7002 14V4Z'
                fill={color}
                fillRule='evenodd'/>
            <path
                d='M2.93652 13.0751L3.46415 13.9246L3.7002 13.778V12.6008L2.93652 13.0751Z'
                fill={color}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default MuseumIcon;
